import {connect} from "react-redux";
import {AudioWrapper} from "../../../../Components/AudioWrapper";
import ChatAvatar from "../../../../Components/ChatAvatar";

const iconVoiceMessage = <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.39286 3.05307V3.05263C8.39286 1.76874 7.31354 0.75 6 0.75C4.68646 0.75 3.60714 1.76874 3.60714 3.05263V7.15789C3.60714 8.44178 4.68646 9.46053 6 9.46053C7.3145 9.46053 8.38547 8.44095 8.38571 7.15833V7.15789L8.39286 3.05307ZM9.53034 7.34333C9.42618 9.13007 7.80255 10.3974 6 10.3974C4.19745 10.3974 2.57381 9.13006 2.46966 7.34333C2.45608 7.11036 2.26647 6.90789 2.01429 6.90789H1.2C0.954641 6.90789 0.742602 7.1092 0.755057 7.36985C0.865396 9.67881 2.75636 11.5477 5.03571 11.9681V13.8C5.03571 14.0485 5.23719 14.25 5.48571 14.25H6.51429C6.76281 14.25 6.96429 14.0485 6.96429 13.8V11.9687C9.24438 11.5541 11.135 9.68465 11.245 7.36979C11.2574 7.10921 11.0454 6.90789 10.8 6.90789H9.98571C9.73353 6.90789 9.54392 7.11036 9.53034 7.34333Z" fill="#1F86FF" stroke="#77E7D3" strokeWidth="0.5"/>
</svg>;

const MessageVoice = ({message, directionMine, activeChat, bots}) => {
    return message.file_url && <div className="i-chats-dialogue-content-message-voice">
        <AudioWrapper srcAudio={message.file_url}/>
        <div className="i-chats-dialogue-content-message-voice-avatar">
            <div className="i-chats-dialogue-content-message-voice-avatar-img">
                <ChatAvatar chat={
                    !directionMine ?
                        activeChat :
                        {
                            name: bots[0].name,
                            avatar_url: bots[0].photo
                        }
                }/>
            </div>
            {iconVoiceMessage}
        </div>
    </div>
}

const mapStateToProps = state => ({
    activeChat: state.Chats.activeChat,
    bots: state.Bots.bots,
});


export default connect(mapStateToProps)(MessageVoice);
